import { colors, type Theme } from '@mui/material';
import { blendColors, desaturateColor } from '@pn/services/utils/color';

declare module '@mui/material/styles' {
  interface Theme {
    borderColor: string;
    productionColors: {
      generalProduction: string;
      oilProduction: string;
      gasProduction: string;
      nglAndCondensateProduction: string;
    };
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    borderColor?: string;
    productionColors?: {
      generalProduction: string;
      oilProduction: string;
      gasProduction: string;
      nglAndCondensateProduction: string;
    };
  }

  interface TypeBackground {
    secondary: string;
  }

  interface TypeBackgroundOptions {
    secondary?: string;
  }

  // used in StackDark.ts
  interface PaletteOptions {
    DataGrid?: {
      bg?: string;
      headerBg?: string;
      pinnedBg?: string;
    };
  }
}

export const sharedThemeTokens: Partial<Theme> = {
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontWeight: 400,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
};

export const productionColors = {
  generalProduction: desaturateColor(colors.amber[500], 0.2),
  oilProduction: colors.green[600],
  gasProduction: colors.red[400],
  nglAndCondensateProduction: colors.deepPurple[400],
};

export const getToolbarColor = (theme: Theme) => {
  return blendColors(
    theme.palette.grey[500],
    theme.palette.background.paper,
    theme.palette.action.selectedOpacity
  );
};

export const pnFontFamily = '"Inter Variable", sans-serif';
export const typography = {
  fontFamily: pnFontFamily,
};
